import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';
import "./Menu.scss";

function ChatMenu(props) {
  const [menuVisible, setMenuVisible] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChangeOption = (option) => {
    if (typeof props.setSelectedOption === "function") {
      props.setSelectedOption(option);
    } 
    setMenuVisible(false);
  };

  return (
    <div className="menu-container" ref={menuRef}>
      {menuVisible && (
        <div className="dropdown-menu">
          {props.menuOptions.map((opcion, index) => (
            <div
              key={index}
              className={`menu-item ${props.selectedOption === opcion ? "active" : ""}`}
              onClick={() => handleChangeOption(opcion)}
            >
              {opcion}
            </div>
          ))}
        </div>
      )}
      <button
        className="list-btn"
        onClick={() => setMenuVisible(!menuVisible)}
        aria-expanded={menuVisible}
        aria-haspopup="listbox"
        disabled={props.loading || props.loadingProgress}
      >
        <FontAwesomeIcon icon={faList} />
      </button>
    </div>
  );
}

export default ChatMenu;